var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "col routes-box" },
    [
      _vm._l(_vm.data.addresses, function(address, index) {
        return _c("div", { key: "address-prefix-" + index }, [
          _c("div", { staticClass: "row mb-3" }, [
            _c(
              "div",
              {
                staticClass: "col-1 text-left",
                class: {
                  "border-h-animate": index < _vm.data.addresses.length - 1
                }
              },
              [
                _c("i", {
                  staticClass: "fa fa-circle",
                  class: [address.type_id === 1 ? "c-pickup" : "c-delivery"]
                })
              ]
            ),
            _vm._v(" "),
            _c(
              "div",
              {
                staticClass:
                  "col-12 col-md-11 col-lg-11 col-xl-11 addresses-wrap pl-0"
              },
              [
                _c("div", { staticClass: "row" }, [
                  _c("div", { staticClass: "col" }, [
                    _c("div", { staticClass: "row mb-1" }, [
                      _c("div", { staticClass: "col" }, [
                        _c(
                          "div",
                          {
                            staticClass: "btn-group btn-group-toggle mb-2",
                            class: {
                              disabled: _vm.inactiveStatus || !_vm.hasAccess
                            }
                          },
                          [
                            _c(
                              "label",
                              {
                                staticClass: "btn",
                                class: { "btn-primary": address.type_id === 1 },
                                on: {
                                  click: function($event) {
                                    _vm.canSwitchRoute && (address.type_id = 1)
                                  }
                                }
                              },
                              [
                                _c("input", {
                                  class: {
                                    disabled:
                                      _vm.inactiveStatus || !_vm.hasAccess
                                  },
                                  attrs: {
                                    type: "radio",
                                    name: "options",
                                    autocomplete: "off",
                                    disabled:
                                      _vm.inactiveStatus || !_vm.hasAccess,
                                    checked: ""
                                  },
                                  on: { click: _vm.toggleEditField }
                                }),
                                _vm._v(" Pickup\n                  ")
                              ]
                            ),
                            _vm._v(" "),
                            _c(
                              "label",
                              {
                                staticClass: "btn",
                                class: [
                                  { "btn-primary": address.type_id === 2 },
                                  {
                                    disabled:
                                      _vm.inactiveStatus || !_vm.hasAccess
                                  }
                                ],
                                on: {
                                  click: function($event) {
                                    _vm.canSwitchRoute && (address.type_id = 2)
                                  }
                                }
                              },
                              [
                                _c("input", {
                                  class: {
                                    disabled:
                                      _vm.inactiveStatus || !_vm.hasAccess
                                  },
                                  attrs: {
                                    disabled:
                                      _vm.inactiveStatus || !_vm.hasAccess,
                                    type: "radio",
                                    name: "options",
                                    autocomplete: "off"
                                  },
                                  on: { click: _vm.toggleEditField }
                                }),
                                _vm._v(
                                  "\n                    Delivery\n                  "
                                )
                              ]
                            )
                          ]
                        )
                      ])
                    ])
                  ])
                ]),
                _vm._v(" "),
                _c("div", { staticClass: "row" }, [
                  _c(
                    "div",
                    {
                      staticClass:
                        "col-12 col-lg-6 col-md-6 col-xl-6 pr-3 pr-md-1 pr-lg-1 pr-xl-1 mb-2 mb-lg-0 mb-md-0 mb-xl-0"
                    },
                    [
                      _c("div", { staticClass: "select-wrap" }, [
                        _c("label", [
                          _vm._v(
                            _vm._s(
                              address.type_id === 1
                                ? "Pickup address"
                                : "Delivery address"
                            )
                          )
                        ]),
                        _vm._v(" "),
                        _c("input", {
                          directives: [
                            {
                              name: "model",
                              rawName: "v-model",
                              value: address.full_address,
                              expression: "address.full_address"
                            }
                          ],
                          staticClass: "form-control",
                          attrs: {
                            type: "text",
                            disabled: _vm.inactiveStatus || !_vm.hasAccess
                          },
                          domProps: { value: address.full_address },
                          on: {
                            input: [
                              function($event) {
                                if ($event.target.composing) {
                                  return
                                }
                                _vm.$set(
                                  address,
                                  "full_address",
                                  $event.target.value
                                )
                              },
                              function($event) {
                                _vm.getAddressData(address.full_address, index)
                              }
                            ],
                            keydown: function($event) {
                              if (
                                !("button" in $event) &&
                                _vm._k($event.keyCode, "down", 40, $event.key, [
                                  "Down",
                                  "ArrowDown"
                                ])
                              ) {
                                return null
                              }
                              $event.preventDefault()
                              $event.target.nextElementSibling &&
                                $event.target.nextElementSibling.firstChild.focus()
                            },
                            keyup: function($event) {
                              _vm.$emit("toggleEditField")
                            }
                          }
                        }),
                        _vm._v(" "),
                        _vm.showDropdown[index] === true && _vm.addresses[index]
                          ? _c(
                              "div",
                              {
                                staticClass:
                                  "dropdown-menu show address-field-wrap",
                                attrs: { "aria-labelledby": "dropdownMenu2" }
                              },
                              _vm._l(_vm.addresses[index], function(
                                addressItem,
                                indexAddr
                              ) {
                                return _c(
                                  "button",
                                  {
                                    key: "btn-prefix-" + indexAddr,
                                    staticClass: "dropdown-item",
                                    attrs: { type: "button" },
                                    on: {
                                      click: function($event) {
                                        _vm.$emit(
                                          "setAddress",
                                          addressItem,
                                          index
                                        )
                                      },
                                      keydown: [
                                        function($event) {
                                          if (
                                            !("button" in $event) &&
                                            _vm._k(
                                              $event.keyCode,
                                              "enter",
                                              13,
                                              $event.key,
                                              "Enter"
                                            )
                                          ) {
                                            return null
                                          }
                                          _vm.$emit(
                                            "setAddress",
                                            addressItem,
                                            index
                                          )
                                        },
                                        function($event) {
                                          if (
                                            !("button" in $event) &&
                                            _vm._k(
                                              $event.keyCode,
                                              "down",
                                              40,
                                              $event.key,
                                              ["Down", "ArrowDown"]
                                            )
                                          ) {
                                            return null
                                          }
                                          $event.preventDefault()
                                          $event.target.nextElementSibling.focus()
                                        },
                                        function($event) {
                                          if (
                                            !("button" in $event) &&
                                            _vm._k(
                                              $event.keyCode,
                                              "up",
                                              38,
                                              $event.key,
                                              ["Up", "ArrowUp"]
                                            )
                                          ) {
                                            return null
                                          }
                                          $event.target.previousElementSibling.focus()
                                        }
                                      ]
                                    }
                                  },
                                  [
                                    _vm._v(
                                      "\n                  " +
                                        _vm._s(addressItem.full_address) +
                                        "\n                "
                                    )
                                  ]
                                )
                              })
                            )
                          : _vm._e()
                      ])
                    ]
                  ),
                  _vm._v(" "),
                  _c(
                    "div",
                    {
                      staticClass:
                        "col-4 col-lg-2 col-xl-2 col-md-2 pr-1 px-md-1 px-lg-1 px-xl-1"
                    },
                    [
                      _c("div", { staticClass: "select-wrap" }, [
                        _c("label", [_vm._v("Floor")]),
                        _vm._v(" "),
                        _c("input", {
                          directives: [
                            {
                              name: "model",
                              rawName: "v-model",
                              value: address.floor,
                              expression: "address.floor"
                            }
                          ],
                          staticClass: "form-control",
                          attrs: {
                            type: "text",
                            disabled: _vm.inactiveStatus || !_vm.hasAccess
                          },
                          domProps: { value: address.floor },
                          on: {
                            keyup: function($event) {
                              _vm.$emit("toggleEditField")
                            },
                            input: function($event) {
                              if ($event.target.composing) {
                                return
                              }
                              _vm.$set(address, "floor", $event.target.value)
                            }
                          }
                        })
                      ])
                    ]
                  ),
                  _vm._v(" "),
                  _c(
                    "div",
                    {
                      staticClass:
                        "col-4 col-lg-2 col-xl-2 col-md-2 pl-1 px-md-1 px-lg-1 px-xl-1"
                    },
                    [
                      _c("div", { staticClass: "select-wrap" }, [
                        _c("label", [_vm._v("Apt.")]),
                        _vm._v(" "),
                        _c("input", {
                          directives: [
                            {
                              name: "model",
                              rawName: "v-model",
                              value: address.apartment,
                              expression: "address.apartment"
                            }
                          ],
                          staticClass: "form-control",
                          attrs: {
                            type: "text",
                            disabled: _vm.inactiveStatus || !_vm.hasAccess
                          },
                          domProps: { value: address.apartment },
                          on: {
                            keyup: function($event) {
                              _vm.$emit("toggleEditField")
                            },
                            input: function($event) {
                              if ($event.target.composing) {
                                return
                              }
                              _vm.$set(
                                address,
                                "apartment",
                                $event.target.value
                              )
                            }
                          }
                        })
                      ])
                    ]
                  ),
                  _vm._v(" "),
                  _c(
                    "div",
                    { staticClass: "col-1 text-center px-1" },
                    [
                      _vm.activeStatus
                        ? [
                            index !== 0
                              ? _c(
                                  "div",
                                  {
                                    class: {
                                      disabled:
                                        _vm.inactiveStatus || !_vm.hasAccess
                                    },
                                    on: {
                                      click: function($event) {
                                        _vm.switchRoute(
                                          "switchRoute",
                                          "up",
                                          index
                                        )
                                      }
                                    }
                                  },
                                  [_c("span", { staticClass: "btn-arrow-up" })]
                                )
                              : _vm._e(),
                            _vm._v(" "),
                            index < _vm.addresses.length - 1
                              ? _c(
                                  "div",
                                  {
                                    class: {
                                      disabled:
                                        _vm.inactiveStatus || !_vm.hasAccess
                                    },
                                    on: {
                                      click: function($event) {
                                        _vm.switchRoute(
                                          "switchRoute",
                                          "down",
                                          index
                                        )
                                      }
                                    }
                                  },
                                  [
                                    _c("span", {
                                      staticClass: "btn-arrow-down"
                                    })
                                  ]
                                )
                              : _vm._e()
                          ]
                        : _vm._e()
                    ],
                    2
                  ),
                  _vm._v(" "),
                  _c("div", { staticClass: "col-1 pt-3" }, [
                    _vm.$_can(_vm.permission) && _vm.activeStatus
                      ? _c(
                          "div",
                          {
                            staticClass: "btn-clear",
                            class: {
                              disabled: _vm.inactiveStatus || !_vm.hasAccess
                            },
                            on: {
                              click: function($event) {
                                _vm.removeAddress("removeAddress", index)
                              }
                            }
                          },
                          [_c("span", { staticClass: "mod-icon-clear" })]
                        )
                      : _vm._e()
                  ])
                ]),
                _vm._v(" "),
                _c("error-field", {
                  attrs: {
                    errors: _vm.errors,
                    field: "addresses." + index + ".postal_code"
                  }
                })
              ],
              1
            )
          ])
        ])
      }),
      _vm._v(" "),
      _c("div", { staticClass: "row mb-3" }, [
        _c("div", { staticClass: "col-1" }),
        _vm._v(" "),
        _c(
          "div",
          {
            staticClass:
              "col-12 col-xl-11 col-lg-11 col-md-11 pl-4 pl-md-0 pl-lg-0 pl-xl-0"
          },
          [
            _vm.$_can(_vm.permission) && _vm.activeStatus
              ? _c(
                  "button",
                  {
                    staticClass: "btn add-button",
                    class: { disabled: _vm.inactiveStatus || !_vm.hasAccess },
                    attrs: {
                      type: "button",
                      disabled: _vm.inactiveStatus || !_vm.hasAccess
                    },
                    on: {
                      click: function($event) {
                        _vm.$emit("addAddress", 1)
                      }
                    }
                  },
                  [_vm._m(0), _vm._v("Add address\n      ")]
                )
              : _vm._e()
          ]
        )
      ]),
      _vm._v(" "),
      _c("div", { staticClass: "row justify-content-center" }, [
        _c("div", { staticClass: "col-10 select-wrap" }, [
          _c("label", { staticClass: "d-inline-block" }, [
            _vm._v("\n        Location notes\n      ")
          ]),
          _vm._v(" "),
          _c("textarea", {
            directives: [
              {
                name: "model",
                rawName: "v-model",
                value: _vm.data.address_note,
                expression: "data.address_note"
              }
            ],
            staticClass: "form-control mb-2 input-address-note",
            attrs: { disabled: _vm.inactiveStatus || !_vm.hasAccess },
            domProps: { value: _vm.data.address_note },
            on: {
              keyup: function($event) {
                _vm.$emit("toggleEditField")
              },
              input: function($event) {
                if ($event.target.composing) {
                  return
                }
                _vm.$set(_vm.data, "address_note", $event.target.value)
              }
            }
          })
        ])
      ])
    ],
    2
  )
}
var staticRenderFns = [
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("span", [_c("span", { staticClass: "mod-icon-add" })])
  }
]
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-469ac71e", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-469ac71e","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/JobsLeadsAddresses.vue
// module id = null
// module chunks = 